//
//  I09DIMCIRCI18n.js
//
//  Created by Sébastien Hecart on 2017-11-05 14:03:18 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//

export default {
  I09DIMCIRC_SECTION_0_TITLE: 'Calculez le débit nécessaire pour une puissance donnée',
  I09DIMCIRC_in_puissanceGenerateur: 'Puissance générateur',
  I09DIMCIRC_in_deltaK: 'Delta température',
  I09DIMCIRC_viscosite_uuid: '',
  I09DIMCIRC_SECTION_1_TITLE: '',
  I09DIMCIRC_res_debitNecessaire: 'Débit nécessaire',
  I09DIMCIRC_viscosite_uuid_mail: 'Température moyenne'
}
